export default "__VITE_ASSET__$mh28ZRw__";